import React, {useRef, useState} from 'react';
import {RefreshControl, ScrollView, StyleSheet, View} from 'react-native';
import {Observer} from 'mobx-react-lite';

import DiscoverTile from '../../components/articleTile/DiscoverTile';
import DiscoverFilters from '../../components/DiscoverFilters';
import RightSideFilters from '../../components/RightSideFilters';
import ScrollToTopButton from '../../components/ScrollToTopButton';
import ContentView from '../../components/ui-controls/layout/ContentView';
import WebFooter from '../../components/WebFooter';
import {useWebScreenDimensions} from '../../hooks/useWebScreenDimensions';
import {useStores} from '../../stores/use-stores';
import {chunkIntoN} from '../../utils/functions';

const DiscoverListScreen = () => {
  const {feedStore} = useStores();
  const {isWebDesktopScreen} = useWebScreenDimensions();

  const [, setRefreshing] = React.useState(false);

  // Scroll button stuff
  const [showScrollButton, setShowScrollButton] = useState(false);
  const listRef = useRef();

  const refresh = () => {
    setRefreshing(true);
    feedStore.getSegments();
    feedStore.loadFeedList();
  };

  const renderDiscoveryTile = item => (
    <DiscoverTile item={item} key={item.id} />
  );

  const numberOfColumns = isWebDesktopScreen ? 4 : 2;

  return (
    <RightSideFilters menuWidthProportion={0.7} menu={<DiscoverFilters />}>
      <ContentView testID="discover-screen">
        <Observer>
          {() => {
            const discoveryList = feedStore.getDiscoverList();
            const chunks = chunkIntoN(discoveryList, numberOfColumns);
            const leftChunk = chunks[0];
            const rightChunk = chunks[chunks.length - 1];
            const middleChunks = chunks.slice(1, chunks.length - 1);

            return (
              <ScrollView
                refreshControl={
                  <RefreshControl refreshing={false} onRefresh={refresh} />
                }
                showsVerticalScrollIndicator={isWebDesktopScreen}
                showsHorizontalScrollIndicator={isWebDesktopScreen}
                // Handle scroll to top button
                onScrollBeginDrag={() => setShowScrollButton(true)}
                onMomentumScrollBegin={() => setShowScrollButton(true)}
                onMomentumScrollEnd={() => setShowScrollButton(false)}
                onScrollEndDrag={() => setShowScrollButton(false)}
                ref={listRef}>
                <View
                  style={styles.columns}
                  testID="discover-list-screen-content-columns">
                  <View
                    key="left"
                    style={styles.leftColumn}
                    testID="discover-list-screen-content-left-column">
                    {leftChunk.map(renderDiscoveryTile)}
                  </View>
                  {middleChunks.map((chunk, i) => (
                    <View
                      style={styles.middleColumns}
                      key={`middle-${i}`}
                      testID="discover-list-screen-content-middle-column">
                      {chunk.map(renderDiscoveryTile)}
                    </View>
                  ))}
                  <View
                    key="right"
                    style={styles.rightColumn}
                    testID="discover-list-screen-content-right-column">
                    {rightChunk.map(renderDiscoveryTile)}
                  </View>
                </View>
                {/* TODO: The WebFooter should be in a global/common place */}
                {!!isWebDesktopScreen && <WebFooter />}
              </ScrollView>
            );
          }}
        </Observer>
        <ScrollToTopButton
          open={showScrollButton}
          callback={() =>
            listRef.current.scrollTo({x: 0, y: 0, animated: true})
          }
        />
      </ContentView>
    </RightSideFilters>
  );
};

export default DiscoverListScreen;

const styles = StyleSheet.create({
  columns: {
    flexDirection: 'row',
    flex: 1,
  },
  leftColumn: {
    flex: 1,
    paddingRight: 8,
  },
  middleColumns: {
    flex: 1,
    paddingHorizontal: 8,
  },
  rightColumn: {
    flex: 1,
    paddingLeft: 8,
  },
});
